module.exports = __webpack_public_path__ + "img/percent-up.973d0675.svg";